import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import Tab from "@material-ui/core/Tab";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";

import { bindActionCreators } from "redux";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import Paper from "@material-ui/core/Paper";
import headersList from "Constants/headersList";
import { Helmet } from "react-helmet";
import emptyPage from "Assets/Images/undraw_no_data_qbuo.svg";
import {
  List,
  TDTypeConsts,
  CreateComp,
} from "Module/Subscription/business-configration/commons";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
// import Popover from "@material-ui/core/Popover";
// import Paper from "@material-ui/core/Paper";
// import MenuListComponent from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import TabContainer from "Component/Common/TabContainer";
import PageHeader from "Component/Headers/pageHeader";
import SearchSq from "Component/Material-ui/SearchSq";
// import {
//   List,
//   TDTypeConsts,
// } from "Module/Subscription/business-configration/commons";
import { instance } from "Actions/AxiosInstance";
import Grid from "@material-ui/core/Grid";
import AddScreeningQuestion from "./AddScreeningQuestion";
import CustomLoader from "Component/CustomLoader";

const tempparticipant = [
  {
    participantdayid: null,
    participanttypeid: 1,
  },
];
let shouldCallAPI = true;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      permissiondenied: false,
      listdata: [],
      backupList: [],
      isdata: false,
      offset: 0,
      limit: 10,
      value: 0,
      data: false,
      createmenu: null,
      selectedReview: null,
      selectedRow: null,
      newquestion: false,
      nofuel: false,
      questioncategoryid: null,
      functionalQuestions: {
        headers: [
          {
            key: "questiontext",
            name: "Question",
            style: { textAlign: "left", width: "40%" },
          },
          {
            key: "inputvaluetypeid",
            name: "Type",
            type: TDTypeConsts.ANSWER_TYPE,
            style: { textAlign: "left" },
          },
          {
            key: "imagepath",
            name: "Created By",
            type: TDTypeConsts.CREATED_BY,
          },
          {
            key: "isactive",
            name: "Status",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },
          {
            key: "moreoptions",
            type: TDTypeConsts.MORE_OPTIONS,
          },
        ],
        listdata: [],
      },
      culturalQuestions: {
        headers: [
          {
            key: "questiontext",
            name: "Question",
            style: { textAlign: "left", width: "40%" },
          },
          {
            key: "inputvaluetypeid",
            name: "Type",
            type: TDTypeConsts.ANSWER_TYPE,
            style: { textAlign: "left" },
          },
          {
            key: "imagepath",
            name: "Created By",
            type: TDTypeConsts.CREATED_BY,
          },
          {
            key: "isactive",
            name: "Status",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },

          {
            key: "moreoptions",
            type: TDTypeConsts.MORE_OPTIONS,
          },
        ],
        listdata: [],
      },
    };
    this.searchTemplate = this.searchTemplate.bind(this);
    this.getAllQuestion = this.getAllQuestion.bind(this);
    this.renderList = this.renderList.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.create = this.create.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.createNewMenuClose = this.createNewMenuClose.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  // handleTabChange(value) {
  //   this.getAllQuestion(value);
  // }

  handleTabChange(value) {
    this.setState(
      {
        value,
      },
      () => {
        this.getAllQuestion();
      },
    );
  }

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (shouldCallAPI) {
        if (this.state.fullcount > this.state.offset) {
          shouldCallAPI = false;
          this.setState(
            {
              offset: this.state.offset + 10,
            },
            () => this.callAllLeavePolicy(),
          );
          setTimeout(() => {
            shouldCallAPI = true;
          }, 5000);
        } else {
          this.setState({
            message: "no data",
          });
        }
      }
    }
  };

  onCancel = () => {
    const postData = {
      questionid: null,
      questioncategoryid: null,
      questiontext: null,
      inputvaluetypeid: 0,
      questioninputoption: [],
      isactive: true,
    };
    this.setState(
      {
        // newpolicycreate: true,
        postData,
      },
      () => {
        this.props.history.push(`${this.props.match.path}`);
      },
    );
  };

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("screeningQuestions");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getAllQuestion();
        if (!this.state.permissions.editable) {
          const index =
            this.state.functionalQuestions &&
            this.state.functionalQuestions.headers &&
            this.state.functionalQuestions.headers.findIndex(
              (x) => x.type == TDTypeConsts.MORE_OPTIONS,
            );
          if (index != -1) {
            this.state.functionalQuestions &&
              this.state.functionalQuestions.headers &&
              this.state.functionalQuestions.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index =
            this.state.functionalQuestions &&
            this.state.functionalQuestions.headers &&
            this.state.functionalQuestions.headers.findIndex(
              (x) => x.type == TDTypeConsts.STATE_ACTIVE_INACTIVE,
            );
          if (index != -1) {
            this.state.functionalQuestions &&
              this.state.functionalQuestions.headers &&
              this.state.functionalQuestions.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index =
            this.state.culturalQuestions &&
            this.state.culturalQuestions.headers &&
            this.state.culturalQuestions.headers.findIndex(
              (x) => x.type == TDTypeConsts.MORE_OPTIONS,
            );
          if (index != -1) {
            this.state.culturalQuestions &&
              this.state.culturalQuestions.headers &&
              this.state.culturalQuestions.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index =
            this.state.culturalQuestions &&
            this.state.culturalQuestions.headers &&
            this.state.culturalQuestions.headers.findIndex(
              (x) => x.type == TDTypeConsts.STATE_ACTIVE_INACTIVE,
            );
          if (index != -1) {
            this.state.culturalQuestions &&
              this.state.culturalQuestions.headers &&
              this.state.culturalQuestions.headers.splice(index, 1);
          }
        }
      });

      if (this.props.history.location.pathname.includes("create")) {
        this.props.history.push(`${this.props.match.path}`);
      }
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  searchTemplate(e) {
    const { value, culturalQuestions, functionalQuestions, backupList } =
      this.state;
    const list =
      value == 0 ? culturalQuestions.listdata : functionalQuestions.listdata;
    const filterList = list.filter(
      (item) =>
        item.questiontext.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      culturalQuestions: {
        ...culturalQuestions,
        listdata: e.target.value
          ? filterList
          : backupList.filter((item) => item.questioncategoryid == 1),
      },
      functionalQuestions: {
        ...functionalQuestions,
        listdata: e.target.value
          ? filterList
          : backupList.filter((item) => item.questioncategoryid == 2),
      },
    });
  }

  getAllQuestion() {
    const { value, questioncategoryid } = this.state;
    this.setState({isLoading:true}, () => {
      instance
      .post("recruit/getallquestionbycategory", {
        // isculture: value == 0 ? false : true,
        questioncategoryid: value == 0 ? 1 : 2,
        isactive: null,
        istemplate: true,
        offset: 0,
        limit: 10,
      })
      .then((resp) => {
        if (value == 0) {
          this.setState({
            culturalQuestions: {
              ...this.state.culturalQuestions,
              listdata: resp.data.result.filter(
                (x) => x.questioncategoryid == 1,
              ),
            },
            backupList: resp.data.result,
            data: true,
            isLoading: false
          });
        } else {
          this.setState({
            functionalQuestions: {
              ...this.state.functionalQuestions,
              listdata: resp.data.result.filter(
                (x) => x.questioncategoryid == 2,
              ),
            },
            backupList: resp.data.result,
            data: true,
            isLoading: false
          });
        }
      })
      .catch((error) => {
        this.setState({isLoading: false})
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    })
   
  }

  create() {
    return (
      !this.state.nofuel && (
        <AddScreeningQuestion
          {...this.props}
          {...this.state}
          // tempdata={tempdata}
          getAllQuestion={this.getAllQuestion}
          onCancel={this.onCancel}
        />
      )
    );
  }

  async onCreate() {
    const postData = {
      questionid: null,
      questioncategoryid: null,
      questiontext: null,
      inputvaluetypeid: 0,
      questioninputoption: [],
      isactive: true,
    };
    this.setState(
      {
        // newpolicycreate: true,
        postData,
      },
      () => {
        this.props.history.push(`${this.props.match.path}/create`);
      },
    );
  }

  // onCreate() {
  //   // this.setState({
  //   //   newquestion: true,
  //   // });
  //   this.props.history.push(`${this.props.match.path}/create`);
  // }

  onEdit() {
    const { selectedRow } = this.state;
    instance
      .get(`/recruit/getquestionbyid/${selectedRow.questionid}`)
      .then((resp) => {
        this.setState(
          { postData: resp.data.result[0], createmenu: false },
          () => {
            this.props.history.push(`${this.props.match.url}/create`);
          },
        );
      });
  }

  onDelete() {
    const { selectedRow } = this.state;
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .post(`recruit/deletequestion`, {
                questionid: selectedRow.questionid,
              })
              .then(
                () => {
                  this.props.closeSnackbar();
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                  this.setState(
                    {
                      // backupList: [],
                      totalcount: 1,
                      data: [],
                      offset: 0,
                      createmenu: false,
                    },
                    () => {
                      this.getAllQuestion();
                    },
                  );
                },
                (error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.closeSnackbar();
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                },
              );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  onStateStatusChange = (value, selectedRow) => {
    const data = {
      questionid: selectedRow.questionid ? selectedRow.questionid : null,
      isactive: value == 1 ? true : false,
    };

    this.props.enqueueSnackbar(
      "Are you sure you want to change status of this this question ?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              instance
                .post("recruit/activeinactivequestion", data)
                .then((res) => {
                  this.setState(
                    {
                      isActive: res.data.result,
                    },
                    () => this.getAllQuestion(),
                  );
                });
            }}
          >
            Yes
          </Button>,

          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  };

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  createNewMenuClose() {
    this.setState({ createmenu: false });
  }

  renderList() {
    const { value, selectedRow } = this.state;
    return (
      this.state.data && (
        <div className="content-outer-wrapper">
          <Grid container>
            <Grid item xs={12} md={5} sm={2}>
              <PageHeader header="Screening questions" />
            </Grid>
            <Grid
              item
              md={7}
              sm={2}
              justify="flex-end"
              className="display-flex"
            >
              <div className="floatleft margin-right-16">
                <SearchSq
                  placeholder="Search"
                  value={this.state.searchValue}
                  onChange={this.searchTemplate}
                />
              </div>
              {this.state.permissions.editable && (
                <span className="floatleft">
                  <Button
                    variant="contained"
                    className="btn btn-primary-md-blue"
                    color="primary"
                    onClick={this.onCreate}
                  >
                    New question
                  </Button>
                </span>
              )}
            </Grid>
          </Grid>
          <Tabs
            value={value}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="auto"
          >
            <Tab
              label="Company & Culture questions"
              onClick={() => this.handleTabChange(0)}
              style={{ maxWidth: 300 }}
            />
            <Tab
              label="Functional and role questions"
              onClick={() => this.handleTabChange(1)}
              style={{ maxWidth: 360 }}
            />
          </Tabs>
          <div className="tab-border"></div>
          {this.state.isLoading ? 
          <CustomLoader/> 
:<div>
          {(this.state.value == 0 &&
            this.state.culturalQuestions.listdata.length > 0) ||
          (this.state.value == 1 &&
            this.state.functionalQuestions.listdata.length > 0) ? (
            <div>
              <div className="margin-top-24">
                <TabContainer>
                  {/* <List
                      showOnlyList
                      list={this.state.listdata}
                      permissions={this.state.permissions}
                      headers={this.state.culturalQuestions.headers}
                      onEdit={this.onEdit}
                      onPreview={this.onPreview}
                      onDelete={this.onDelete}
                      onStateStatusChange={this.onStateStatusChange}
                      onMoreOptionClick={this.onMoreOptionClick}
                    /> */}
                  {value == 0 && (
                    <List
                      showOnlyList
                      list={this.state.culturalQuestions.listdata}
                      permissions={this.state.permissions}
                      headers={this.state.culturalQuestions.headers}
                      onEdit={this.onEdit}
                      onPreview={this.onPreview}
                      onDelete={this.onDelete}
                      onStateStatusChange={this.onStateStatusChange}
                      onMoreOptionClick={this.onMoreOptionClick}
                    />
                  )}
                  {value == 1 && (
                    <List
                      showOnlyList
                      list={this.state.functionalQuestions.listdata}
                      permissions={this.state.permissions}
                      headers={this.state.functionalQuestions.headers}
                      onEdit={this.onEdit}
                      onPreview={this.onPreview}
                      onDelete={this.onDelete}
                      onStateStatusChange={this.onStateStatusChange}
                      onMoreOptionClick={this.onMoreOptionClick}
                    />
                  )}
                </TabContainer>
              </div>
              <Popover
                open={this.state.createmenu}
                anchorEl={this.state.create_anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={this.createNewMenuClose}
                className="margin-top-8"
              >
                <Paper style={{ width: 190 }}>
                  <div>
                    <MenuListComponent>
                      {selectedRow && (
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.onEdit}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">Edit </span>
                          </ListItemText>
                        </ListItem>
                      )}
                      {selectedRow && (
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.onDelete}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">
                              Delete{" "}
                            </span>
                          </ListItemText>
                        </ListItem>
                      )}
                    </MenuListComponent>
                  </div>
                </Paper>
              </Popover>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                }}
              >
                <img src={emptyPage} alt="image"></img>
                <p className="large-text-dark">
                  There are no questions to display
                </p>
                <p classNAme="normal-dark-secondary">
                  Get started by creating your screening question!
                </p>
              </div>
            </div>
          )}
          </div>
}
        </div>
      )
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.ATS.ScreeningQuestions.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            {this.state.data && (
              <div>
                <div>
                  <Switch>
                    <Route
                      exact
                      path={`${match.path}`}
                      render={this.renderList}
                    />
                    <Route
                      exact
                      path={`${match.path}/create`}
                      render={this.create}
                    />
                    <Redirect from={`${match.path}`} to={`${match.path}`} />
                  </Switch>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);
